import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useCart } from "../Context/CartContext";
import "./Shop.css";
import BASE_URL from "../config";

function Shop() {

  const [products, setProducts] = useState([]);
  const navigate = useNavigate();
  const { addToCart } = useCart();
 useEffect(() => {

  fetch(`${BASE_URL}/api/products/allproducts`)
    .then(res => res.json())
    .then(data => {

      console.log(data); // pehle ye check karo

      setProducts(data.products);

    })
    .catch(err => console.log(err));

}, []);


  return (
    <div className="shop-container">

      <h1 className="shop-title-color">
        CRAFTED FOR THE JOURNEY
      </h1>

      <div className="products-grid">

        {products.map((product) => (
          <div 
 className="product-card"
 key={product.id}
 onClick={() => navigate(`/product/${product.id}`)}
>

            <img
              src={`https://sahscents.xpertoneevents.com/uploads/${product.image}`}
              alt={product.name}
            />

            <h3>{product.name}</h3>

            <p>
              ${product.price}
            </p>

          <button
  onClick={(e) => {
    e.stopPropagation(); // Card click hone se rokega

    addToCart(product, 1);

    Swal.fire({
      toast: true,
      position: "top-end",
      icon: "success",
      title: `${product.name} added to cart`,
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,
    });
  }}
>
  Add To Cart
</button>

          </div>
        ))}

      </div>

    </div>
  );
}

export default Shop;